import React from 'react';
import { BLOCKS, Block, Inline } from '@contentful/rich-text-types';

import { IInfoBlockFields } from '../../../types/contentful';

import { Text } from '../Text';
import { Box } from '../Box';
import RichText from '../RichText';
import { BlockContainer, Layout, Column } from '../Layout';

import {
  TextWrapper,
  Wrapper,
  ListItem,
  StyledImage,
  InfoBlockContainer
} from './styles';
import { getImageData } from 'src/utils/contentful';
import { Asset } from 'contentful';

export function InfoBlock({
  headingText,
  centerAlign,
  bodyCopy,
  upperLeftIcon,
  optionalBackgroundColor
}: IInfoBlockFields) {
  const textAlign = centerAlign ? 'center' : 'left';

  return (
    <BlockContainer
      data-blockid="infoBlock"
      data-testid="infoBlock"
      marginTop={{
        0: 'blockMarginY',
        mobile: 's',
        tablet: 'blockMarginY_tablet'
      }}
      marginBottom={{
        0: 'blockMarginY',
        mobile: 'xs',
        tablet: 'blockMarginY_tablet'
      }}
    >
      <Layout>
        <InfoBlockContainer bgColor={optionalBackgroundColor}>
          {upperLeftIcon && (
            <StyledImage {...getImageData(upperLeftIcon as Asset)} />
          )}
          <Column size={12}>
            <Wrapper alignItems="center">
              <TextWrapper padding={{ 0: 'l' }} textAlign={textAlign}>
                <Box marginBottom={{ 0: 'm', desktop: 'xl' }}>
                  <Text
                    as="h2"
                    fontWeight={{ 0: 'h2' }}
                    fontSize={{ 0: 'h2_0', desktop: 'h2_desktop' }}
                    colour={{ 0: 'infoText' }}
                  >
                    {headingText}
                  </Text>
                </Box>
                {bodyCopy && (
                  <Box marginBottom={{ 0: 'ml' }}>
                    <RichText
                      data={bodyCopy}
                      colour="white"
                      bulletColor="green"
                      overrideOptions={{
                        [BLOCKS.LIST_ITEM]: (
                          node: Block | Inline,
                          children: any
                        ) => <ListItem>{children}</ListItem>
                      }}
                    />
                  </Box>
                )}
              </TextWrapper>
            </Wrapper>
          </Column>
        </InfoBlockContainer>
      </Layout>
    </BlockContainer>
  );
}
